import { NOT_FOUND } from 'redux-first-router';

const components = {
  HOME: 'Home',
  DEFAULT: 'Home',
  DEFAULT_LANDER: 'Lander',
  LANDER: 'Lander',
  DEFAULT_SLIDESHOW: 'Slideshow',
  SLIDESHOW: 'Slideshow',
  DEFAULT_HONOREE: 'Article/Article',
  HONOREE: 'Article/Article',
  DEFAULT_COMMITTEE: 'Committee',
  COMMITTEE: 'Committee'
};

export default (state = 'DEFAULT', action = {}) => components[action.type] || state;

// NOTES: this is the primary reducer demonstrating how RFR replaces the need
// for React Router's <Route /> component.
//
// ALSO:  Forget a switch, use a hash table for perf.
